import axios from "axios";
import qs from "qs";
// import store from '@/store'
import { message } from "antd";
import { baseURL } from "../ajax/globalConfig";
import { json, BrowserRouter as Redirect } from "react-router-dom";
// import { useNavigate } from "react-router-dom";

// import router from '@/router'
// const token = "e0ca7510-a3f9-4b15-94df-971f225c7cca";
// console.log(process.env);

// console.log(baseURL);

const service = axios.create({
  baseURL: baseURL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    // admintoken: localStorage.getItem("token") || "",
  },
});

// http请求拦截器
service.interceptors.request.use(
  (config) => {
    if (localStorage.getItem("token")) {
      config.headers.admintoken = localStorage.getItem("token") || "";
    } else {
      config.headers.admintoken = "";
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// http响应拦截器
service.interceptors.response.use(
  (response) => {
   
    const res = response.data;
    // let history = Router();
    const { code, status } = res;
    // code结果代码，0正确，其他皆为错误
    if (String(res.code) !== "0") {
      // let navigete = useNavigate();

      if (code === 401 || status === 401) {
        // return navigete("/login");
        // console.log(useHistory);
        localStorage.clear();
        sessionStorage.clear();
        // return useNavigate()("/login");
        // useHistory.history.push("/login");
        // console.log(Router);
        // Router.push("/login");
        // Router.history.push("/login");
        // history.push("/login");
        // return <Redirect to={"/login"} />;
        // window.location.href = "/login";
        // console.log(this.props);
        // return <Link to={"/login"}></Link>;
      }
      // if (
      //   res.code === 'TOKEN_NOT_EMPTY' ||
      //   res.code === 'INVALID_TOKEN' ||
      //   res.code === 'NOT_LOGIN' ||
      //   res.code === 'TOKEN_EMPTY'
      // ) {
      //   // 重新跳转到登陆页面
      //   message(res.message)
      //   router.beforeEach((to, from) => {
      //     const { redirect } = from.query
      //     if (to.path === "/login") {
      //       window.localStorage.setItem('wxLoginRedirect', redirect || '/index')
      //     }
      //   })
      //   // 视频查看权限--认证页面
      //   const redirect = localStorage.getItem('video-auth-redirect')
      //   setTimeout(() => {
      //     if (redirect) {
      //       router.push({
      //         path: '/login',
      //         query: {
      //           redirect: redirect
      //         }
      //       })
      //     } else {
      //       router.push('/login')
      //     }
      //     localStorage.clear()
      //   }, 800)
      // } else {
      //   // message(res.message + "(" + res.code + ")");
      //   message(res.message)
      // }
      console.log("res", res);
      return Promise.reject(res);
    } else {
      return res;
    }
  },
  (error) => {
    console.log("error", error);
    const errorString = error.toString();
    if (errorString.includes("timeout")) {
      message.error("接口请求超时");
    } else if (errorString.includes("Network Error")) {
      message.error("网络故障，请稍后再试");
    } else if (error.code === "ERR_BAD_REQUEST") {
      // 重定向跳登录
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

service.postJson = function (url, data, headerParam) {
  return service({
    method: "post",
    url,
    data: data,
    headers: headerParam
      ? headerParam
      : {
          "Content-Type": "application/json;charset=UTF-8",
        },
  });
};

service.postJsonUp = function (url, data) {
  return service({
    method: "postJson",
    url,
    data: data,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};

service.post = function (url, data) {
  return service({
    method: "post",
    url,
    data: qs.stringify(data),
  });
};
service.get = function (url, data) {
  url = url + "?" + qs.stringify(data);
  return service({
    method: "get",
    url,
  });
};

service.upload = function (url, data, headers, timeout) {
  return service({
    method: "post",
    url,
    data,
    headers,
    ...timeout,
  });
};

service.downloadGet = function (url) {
  return service({
    method: "get",
    url,
    responseType: "blob",
  });
};

service.download = function (url, data) {
  return service({
    method: "post",
    url,
    data,
    responseType: "blob",
  });
};

export default service;
